@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.service

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

@Serializable
private data class SystemPushJsonEvent(
    val topic: String = "",
    val relativePath: String = "",
    val changedAt: String = ""
)

private external class EventSource(url: String) {
    fun addEventListener(type: String, listener: (dynamic) -> Unit)
    fun close()
    var onerror: ((dynamic) -> Unit)?
}

object SystemPushService {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    private var started = false
    private var source: EventSource? = null

    fun ensureStarted() {
        if (started) return
        started = true
        connect()
    }

    private fun connect() {
        source?.close()
        val eventSource = EventSource("/api/systempush/stream")
        source = eventSource
        eventSource.addEventListener("json-change") { event ->
            val payload = event?.data?.toString().orEmpty()
            val parsed = runCatching { json.decodeFromString<SystemPushJsonEvent>(payload) }.getOrNull() ?: return@addEventListener
            GlobalManager.markJsonChanged(
                topic = parsed.topic,
                relativePath = parsed.relativePath,
                changedAt = parsed.changedAt
            )
        }
        eventSource.onerror = {
            // Native EventSource reconnects on its own. We only recreate the handle if the browser closed it.
            if (source != eventSource) {
                Unit
            }
        }
    }
}
